<template>
  <div>
    <el-drawer
      :modal="false"
      :visible.sync="drawer"
      :with-header="true"
      :modal-append-to-body="false"
      size="65%"
    >
      <h3 slot="title">{{ $t("app.dicItemManagement") }}</h3>
      <div
        class="scroll-bar"
        style="padding: 0px 20px; overflow: auto; height: 100vh"
      >
        <el-button size="small" type="primary" @click="handleNew">{{
          $t("app.new")
        }}</el-button>
        <el-table :data="tableData" stripe style="width: 100%" height="85%">
          <el-table-column
            align="center"
            label="字典項類型編碼"
            prop="typeCode"
          >
          </el-table-column>
          <el-table-column align="center" label="字典項編碼" prop="code">
          </el-table-column>
          <el-table-column
            align="center"
            width="300"
            label="字典項名稱"
            prop="name"
          >
          </el-table-column>
          <el-table-column
            align="center"
            :label="$t('app.enable')"
            prop="enable"
          >
            <template slot-scope="scope">
              {{ scope.row.enable }}
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            :label="$t('app.description')"
            prop="description"
          >
          </el-table-column>
          <el-table-column
            align="right"
            width="150px"
            :label="$t('app.operation')"
          >
            <template slot-scope="scope">
              <el-button
                type="primary"
                size="small"
                @click="handleEdit(scope.$index, scope.row)"
                >{{ $t("app.edit") }}</el-button
              >
              <el-button
                size="small"
                type="danger"
                @click="handleDelete(scope.$index, scope.row)"
                >{{ $t("app.delete") }}</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <el-dialog
          :title="$t('app.delete')"
          :visible.sync="dialogVisible"
          :modal-append-to-body="false"
          width="30%"
        >
          <span>{{ $t("app.isDelete") + "(" + deleteItem + ")" }}</span>
          <span slot="footer" class="dialog-footer">
            <el-button size="small" type="info" @click="dialogVisible = false">{{
              $t("app.cancel")
            }}</el-button>
            <el-button
              size="small"
              type="primary"
              :loading="loading"
              @click="deleteDic()"
              >{{ $t("app.confirm") }}</el-button
            >
          </span>
        </el-dialog>
        <dic-item-modal
          ref="dicItemModal"
          @handleSuccess="updateDic"
          @handleAdd="addDic"
        ></dic-item-modal>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import DicItemModal from "./DictionaryItemModal";
import { del } from "@/api/systemManagement/dictionaryManagement";
export default {
  components: {
    DicItemModal,
  },
  data() {
    return {
      drawer: false,
      options: [
        {
          value: true,
          label: this.$t("app.isUse"),
        },
        {
          value: false,
          label: this.$t("app.disable"),
        },
      ],
      size: 10,
      currentPage: 1,
      total: 100,
      loading: false,
      dialogVisible: false,
      deleteItem: "",
      deleteItemType: "",
      deleteIndex: "",
      tableData: [],
      typeCode: "",
    };
  },
  methods: {
    visible(row) {
      this.typeCode = row.code;
      this.tableData = row.child.map((_) => {
        return {
          description: _.Description,
          typeCode: _.DictTypeCode,
          name: _.DictText,
          code: _.DictCode,
          enable: _.IsUse,
          sort: _.SortNumber,
        };
      });
      this.drawer = true;
    },
    handleEdit(index, row) {
      this.$refs.dicItemModal.edit(index, row);
    },
    updateDic(index, obj) {
      this.tableData.splice(index, 1, obj);
    },
    handleDelete(index, row) {
      this.dialogVisible = true;
      this.deleteItem = row.code;
      this.deleteItemType = row.typeCode;
      this.deleteIndex = index;
    },
    deleteDic() {
      this.loading = true;
      del({ DictTypeCode: this.deleteItemType, DictCode: this.deleteItem })
        .then(() => {
          this.loading = false;
          this.dialogVisible = false;
          this.tableData.splice(this.deleteIndex, 1);
        })
        .catch(() => {
          this.loading = false;
        });
    },
    handleNew() {
      this.$refs.dicItemModal.add(this.typeCode);
    },
    addDic(obj) {
      this.tableData.push(obj);
    },
  },
};
</script>
